var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgMedium(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 16,
    viewBox: "0 0 20 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18.4042 1.88042L20 0.337684V0H14.4717L10.5317 9.90989L6.04917 0H0.2525V0.337684L2.11667 2.60547C2.29833 2.77305 2.39333 3.01811 2.36917 3.26484V12.1768C2.42667 12.4977 2.32333 12.8278 2.1 13.0611L0 15.6328V15.9663H5.95417V15.6286L3.85417 13.0611C3.62667 12.8269 3.51917 12.5027 3.565 12.1768V4.46821L8.79167 15.9705H9.39917L13.8933 4.46821V13.6312C13.8933 13.8728 13.8933 13.9225 13.7367 14.0808L12.12 15.6615V16H19.9633V15.6623L18.405 14.1204C18.2683 14.016 18.1975 13.8408 18.2267 13.6707V2.33011C18.1975 2.15916 18.2675 1.984 18.4042 1.88042Z",
    fill: "#DBD8D7"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedium);
export default __webpack_public_path__ + "static/media/medium.8c5c5c9288dec1ca8d72c44cca8f2596.svg";
export { ForwardRef as ReactComponent };